<template>
  <div class="p-grid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <span>{{ title }}</span>
          <Button label="Tạo văn bản" class="p-button-sm p-button-success" 
            style="float:right;color: white !important;background-color: #32D74B !important;border: 1px solid #32D74B !important;" 
            @click="saveData()"/>
          <Button label="Quay lại" class="p-button-sm p-button-warning" 
            style="float:right;margin-right: 10px;color: black !important;background-color: #FFD60A !important;border: 1px solid #FFD60A !important;" 
            @click="backToList()"/>
        </div>
        <div class="p-fluid p-formgrid p-grid" style="border: 1px solid #c8c8c8; padding: 10px;">
          <div class="p-field p-col-12 p-md-6">
            <div>
              <p style="font-weight: bold;">Thông tin văn bản</p>
              <div class="p-field p-grid">
                <label for="codeArea" class="p-col-fixed" style="width:100px">Mã khu vực</label>
                <div class="p-col">
                  <!-- <InputText id="codeArea" type="text" v-model="codeArea" placeholder="Nhập mã khu vực"/> -->
                  <Dropdown :key="countMKV" id="codeArea" class="p-column-filter" :showClear="true" :filter="true" v-model="codeMKV" :options="arrMKV" optionLabel="name" placeholder="Chọn mã khu vực"/>
                  <small
                    v-if="validationErrors && validationErrors['codeArea']"
                    class="p-invalid"
                  >{{validationErrors['codeArea']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeCourt" class="p-col-fixed" style="width:100px">Mã VB tòa</label>
                <div class="p-col">
                  <InputText id="codeCourt" type="text" v-model="codeCourt" placeholder="Nhập mã tòa"/>
                  <!--<small
                    v-if="validationErrors && validationErrors['codeCourt']"
                    class="p-invalid"
                  >{{validationErrors['codeCourt']}}</small>-->
                  <small
                      v-if="codeCourt_exists"
                      class="p-invalid"
                  >Mã VB tòa đã bị trùng.</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeOffice" class="p-col-fixed" style="width:100px">Mã văn phòng</label>
                <div class="p-col">
                  <!-- <InputText id="codeOffice" type="text" v-model="codeOffice" placeholder="Nhập mã văn phòng"/> -->
                  <Dropdown :key="countMVP" id="codeArea" class="p-column-filter" :showClear="true" :filter="true" @change="onChangeMVP($event)" v-model="codeMVP" :options="arrMVP" optionLabel="name" placeholder="Chọn mã văn phòng"/>
                  <small
                    v-if="validationErrors && validationErrors['codeOffice']"
                    class="p-invalid"
                  >{{validationErrors['codeOffice']}}</small>
                  <small
                    v-if="cOffice_exists"
                    class="p-invalid"
                  >Mã văn phòng không tồn tại</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="isUrgent" class="p-col-fixed" style="width:100px">Văn bản gấp</label>
                <div class="p-col">
                  <Checkbox v-model="isUrgent" :binary="true" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="numberDecision" class="p-col-fixed" style="width:100px">Quyết định số</label>
                <div class="p-col">
                  <InputText id="numberDecision" type="text" v-model="numberDecision" placeholder="Nhập quyết định số"/>
                  <small
                    v-if="validationErrors && validationErrors['numberDecision']"
                    class="p-invalid"
                  >{{validationErrors['numberDecision']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="contentDocument" class="p-col-fixed" style="width:100px">Nội dung văn bản</label>
                <div class="p-col">
                  <InputText id="contentDocument" type="text" v-model="contentDocument" placeholder="Nhập nội dung"/>
                  <small
                    v-if="validationErrors && validationErrors['contentDocument']"
                    class="p-invalid"
                  >{{validationErrors['contentDocument']}}</small>
                </div>
              </div>
              <div class="p-grid">
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 0;">
                    <label for="dateIssued" class="p-col-fixed" style="width:100px">Ngày ban hành</label>
                    <div class="p-col">
                      <Calendar v-model="dateIssued" dateFormat="dd/mm/yy" :showIcon="true" :showButtonBar="true"/>
                      <small
                        v-if="validationErrors && validationErrors['dateIssued']"
                        class="p-invalid"
                      >{{validationErrors['dateIssued']}}</small>
                    </div>
                  </div>
                </div>
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 0;">
                    <label for="dateInvite" class="p-col-fixed" style="width:100px">Ngày mời</label>
                    <div class="p-col">
                      <Calendar v-model="dateInvite" dateFormat="dd/mm/yy" :showIcon="true" :showButtonBar="true"/>
                      <small
                        v-if="validationErrors && validationErrors['dateInvite']"
                        class="p-invalid"
                      >{{validationErrors['dateInvite']}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p style="font-weight: bold;">Thông tin đương sự</p>
              <div class="p-field p-grid">
                <label for="nameLitigant" class="p-col-fixed" style="width:100px">Tên đương sự*</label>
                <div class="p-col">
                  <InputText id="nameLitigant" type="text" v-model="nameLitigant" placeholder="Nhập tên đương sự"/>
                  <small
                    v-if="validationErrors && validationErrors['nameLitigant']"
                    class="p-invalid"
                  >{{validationErrors['nameLitigant']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="stateID" class="p-col-fixed" style="width:100px">Tỉnh/thành phố*</label>
                <div class="p-col">
                  <!-- <InputText id="stateID" type="text" v-model="stateID" placeholder="Chọn Tỉnh/ Thành phố"/> -->
                  <Dropdown :key="countState" id="stateID" class="p-column-filter" :showClear="true" :filter="true" v-model="state" :options="arrState" optionLabel="name" @change="onChangeState()" placeholder="Chọn Tỉnh/ Thành phố"/><!--$event-->
                  <small
                    v-if="validationErrors && validationErrors['state']"
                    class="p-invalid"
                  >{{validationErrors['state']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="districtID" class="p-col-fixed" style="width:100px">Quận/huyện*</label>
                <div class="p-col">
                  <!-- <InputText id="districtID" type="text" v-model="districtID" placeholder="Chọn Quận/ Huyện"/> -->
                  <Dropdown :key="countDist" id="districtID" :showClear="true" :filter="true" v-model="district" :options="arrDistrict" optionLabel="name" @change="onChangeDistrict($event)" placeholder="Chọn Quận/ Huyện"/>
                  <small
                    v-if="validationErrors && validationErrors['district']"
                    class="p-invalid"
                  >{{validationErrors['district']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="wardID" class="p-col-fixed" style="width:100px">Phường/xã*</label>
                <div class="p-col">
                  <!-- <InputText id="wardID" type="text" v-model="wardID" placeholder="Chọn Phường/ Xã"/> -->
                  <Dropdown :key="countWard" id="wardID" :showClear="true" :filter="true" v-model="ward" :options="arrWard" optionLabel="name" @change="onChangeWard($event)" placeholder="Chọn Phường/ Xã"/>
                  <small
                    v-if="validationErrors && validationErrors['ward']"
                    class="p-invalid"
                  >{{validationErrors['ward']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="address" class="p-col-fixed" style="width:100px">Địa chỉ</label>
                <div class="p-col">
                  <InputText id="address" type="text" v-model="address" placeholder="Nhập địa chỉ"/>
                  <small
                    v-if="validationErrors && validationErrors['address']"
                    class="p-invalid"
                  >{{validationErrors['address']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="phoneLitigant" class="p-col-fixed" style="width:100px">Số điện thoại</label>
                <div class="p-col">
                  <InputText v-model="phoneLitigant" id="phoneLitigant" type="number" class="p-col-width" placeholder="Nhập số điện thoại"/>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="p-field p-col-12 p-md-2"/> -->
          <div class="p-field p-col-12 p-md-6">
            <div>
              <p style="font-weight: bold;">Thông tin cơ quan giao</p>
              <div class="p-field p-grid">
                <label for="signer" class="p-col-fixed" style="width:100px">Người ký</label>
                <div class="p-col">
                  <InputText id="signer" type="text" v-model="signer" placeholder="Nhập tên thẩm phán/chấp hành viên"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeAgency" class="p-col-fixed" style="width:100px">Mã cơ quan</label>
                <div class="p-col">
                  <!-- <InputText id="codeAgency" type="text" v-model="codeAgency" placeholder="Nhập mã cơ quan"/> -->
                  <Dropdown :key="countCQ" id="codeAgency" class="p-column-filter" :showClear="true" :filter="true" v-model="codeCQ" :options="arrCQ" optionLabel="name" placeholder="Chọn mã cơ quan"/>
                  <small
                    v-if="validationErrors && validationErrors['codeAgency']"
                    class="p-invalid"
                  >{{validationErrors['codeAgency']}}</small>
                  <small
                    v-if="cAgency_exists"
                    class="p-invalid"
                  >Mã cơ quan không tồn tại</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <!--<label for="costDocument" class="p-col-fixed" style="width:100px">Chi phí văn bản</label>-->
                <label for="costDocument" class="p-col-fixed" style="width:100px">Chi phí cơ quan trả</label>
                <div class="p-col">
                  <InputText :disabled="mode == 'edit'" v-model="costDocument" id="costDocument" type="number" class="p-col-width" placeholder="Nhập chi phí đi Tỉnh hoặc hệ thống sẽ hiển thị nếu Nội Thành"/>
                </div>
              </div>
              <div class="p-field p-grid" v-if="this.$store.getters.role != 'court'">
                <!--<label for="costDocument" class="p-col-fixed" style="width:100px">Chi phí văn bản</label>-->
                <label for="costDocument" class="p-col-fixed" style="width:100px">Chi phí lương</label>
                <div class="p-col">
                  <InputText disabled v-model="amount_salary" id="amount_salary" type="number" class="p-col-width" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="" class="p-col-fixed" style="width:100px">Đối tượng chịu phí</label>
                <div class="p-grid p-fluid">
                  <div class="p-col-12 p-md-6" style="width: 120px;">
                    <RadioButton name="actionBudget" value="ybudget" v-model="isFeeBudget" />
                    <label style="display: unset; margin: 5px;">Ngân sách</label>
                  </div>
                  <div class="p-col-12 p-md-6" style="width: 120px;">
                    <RadioButton name="actionBudget" value="nbudget" v-model="isFeeBudget" />
                    <label style="display: unset; margin: 5px;">Đương sự</label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p style="font-weight: bold;">Thông tin Tống Đạt Viên/ Văn phòng liên kết</p>
              <div class="p-field p-grid">
                <label for="nameTDV" class="p-col-fixed" style="width:100px">Họ và tên TĐV</label>
                <div class="p-col">
                  <!-- <InputText id="nameTDV" type="text" v-model="nameTDV" placeholder="Chọn Tống Đạt viên"/> -->
                  <Dropdown :key="countTDV" id="nameTDV" class="p-column-filter" :showClear="true" :filter="true" v-model="nameTDV" @change="onChangeTDV($event)" :options="arrTDV" optionLabel="name" placeholder="Chọn Tống Đạt viên"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="firstname" class="p-col-fixed" style="width:100px">Số điện thoại</label>
                <div class="p-col">
                  <InputText :disabled="true" v-model="phoneTDV" id="phoneTDV" type="number" class="p-col-width" placeholder="Nhập số điện thoại"/>
                </div>
              </div>
              <div class="p-field p-grid" v-if="this.$store.getters.role != 'court'">
                <label for="codeVPLK" class="p-col-fixed" style="width:100px">Mã văn phòng liên kết</label>
                <div class="p-col">
                  <!-- <InputText id="codeVPLK" type="text" v-model="codeVPLK" placeholder="Chọn văn phòng liên kết"/> -->
                  <Dropdown :key="countVPLK" id="codeVPLK" class="p-column-filter" :showClear="true" :filter="true" v-model="codeVPLK" @change="onChangeVPLK($event)" :options="arrVPLK" optionLabel="name" placeholder="Chọn văn phòng liên kết"/>
                  <!-- <small
                    v-if="validationErrors && validationErrors['codeVPLK']"
                    class="p-invalid"
                  >{{validationErrors['codeVPLK']}}</small> -->
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="firstname" class="p-col-fixed" style="width:100px">Loại văn bản*</label>
                <div class="p-col">
                  <Dropdown id="typeDoc" v-model="type" :options="typeDocs" optionLabel="name"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import gql from 'graphql-tag';
import graphql from '../common/graphql'
import moment from "moment-timezone";
import store from '@/store'
export default {
  components: {
  },
  data() {
    return {
      title: "Thêm văn bản",
      mode: 'add',
      models: {},
      componentKey: 0,
      currUser: null,
      arrState: [],
      arrDistrict: [],
      arrWard: [],
      codeSystem: '',
      codeCourt: '',
      codeArea: '',
      codeMKV: null,
      codeMVP: null,
      codeCQ: null,
      codeOffice: '',
      codeOfficeID: null,
      isUrgent: false,
      numberDecision: '',
      contentDocument: '',
      dateIssued: null,
      dateInvite: null,
      nameLitigant: '',
      address: '',
      state: null,
      ward: null,
      district: null,
      phoneLitigant: null,
      signer: null,
      codeAgency: '',
      codeAgencyID: null,
      costDocument: null,
      amount_salary: 0,
      isFeeBudget: null,
      nameTDV: null,
      arrTDV: [],
      phoneTDV: null,
      codeVPLK: null,
      arrVPLK: [],
      arrMKV:[],
      arrMVP:[],
      arrCQ:[],
      type: {name: 'Loại 1', code: 1},
      typeDocs: [
        {name: 'Loại 1', code: 1}, // VB gửi đương sự, 1 địa chỉ, 1 ngày nhập VB
        {name: 'Loại 2', code: 2}, // giống loại 1, khác đương sự
        {name: 'Loại 3', code: 3}, // cùng đượng sự, cùng ngày nhập, cùng địa chỉ
        {name: 'Loại 4', code: 4}, // VB trả tòa (thất lạc)
        {name: 'Loại 5', code: 5} // VB đi tỉnh
      ],
      countState: 0,
      countDist: 0,
      countWard: 0,
      countTDV: 0,
      countVPLK: 0,
      countMKV: 0,
      countMVP: 0,
      countCQ: 0,
      validationErrors: {},
      cAgency_exists: false,
      cOffice_exists: false,
      codeCourt_exists: false,
      cDocument_exists: false,
      arrDocuments: [],
      users_login: null,
    }
  },
  async mounted () {
    if (store.getters.group_permission && store.getters.group_permission.insert_document.add == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
    this.mode = this.$route.name === 'editDoc' ? 'edit' : this.mode;
    await this.getUserLogin();
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/import-document' });
    },
    async getUserLogin(){
      await this.$apollo.query({
        query: DataServices.getList('accounts', {"fields" : "users {id}"}),
        variables: {
          where_key: {
            id : {'_eq' : this.$store.getters.user}
          }
        },
        fetchPolicy: "no-cache"
      }).then((res) => {
        if (res.data.accounts && res.data.accounts[0] && res.data.accounts[0].users) {
          this.users_login = res.data.accounts[0].users.id
        }
      })
    },
    async checkCode(model, code) {
      await this.$apollo.query({
        query: DataServices.getList(model, {"fields" : "id code"}),
        variables: {
          where_key: {
            code: {'_eq': code.trim()},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      }).then((res) => {
        if (model === 'office_tpl') {
          this.cOffice_exists = false
          if (res.data && res.data[Object.keys(res.data)].length === 0) {
            this.cOffice_exists = true
          } else {
            this.codeOfficeID = res.data.office_tpl[0].id
          }
        } else {
          this.cAgency_exists = false
          if (res.data && res.data[Object.keys(res.data)].length === 0) {
            this.cAgency_exists = true
          } else {
            this.codeAgencyID = res.data.office_agency[0].id
          }
        }
      })
    },
    async validateData() {
      this.validationErrors = {};
      // if (this.codeCourt === '') this.validationErrors['codeCourt'] = 'Vui lòng nhập Mã VB tòa';
      if (this.codeArea === '') this.validationErrors['codeArea'] = 'Vui lòng chọn Mã khu vực';
      // if (this.numberDecision === '') this.validationErrors['numberDecision'] = 'Vui lòng nhập Quyết định số';
      if (this.contentDocument === '') this.validationErrors['contentDocument'] = 'Vui lòng nhập Nội dung văn bản';
      // if (this.dateInvite === null || this.dateInvite === '') this.validationErrors['dateInvite'] = 'Vui lòng nhập Ngày mời';
      // if (this.dateIssued === null || this.dateIssued === '') this.validationErrors['dateIssued'] = 'Vui lòng nhập Ngày ban hành';
      if (this.nameLitigant === null || this.nameLitigant === '') this.validationErrors['nameLitigant'] = 'Vui lòng nhập Tên đương sự';
      if (this.address === null || this.address === '') this.validationErrors['address'] = 'Vui lòng nhập Địa chỉ';
      if (this.state === null || this.state === '') this.validationErrors['state'] = 'Vui lòng nhập Tỉnh/thành';
      //if (this.district === null || this.district === '') this.validationErrors['district'] = 'Vui lòng nhập Quận/huyện';
      console.log('wardasdasda',this.ward)
      if (this.ward === null || this.ward === '') this.validationErrors['ward'] = 'Vui lòng nhập Phường/xã';
      if (this.codeAgency === null || this.codeAgency === '') {
        this.validationErrors['codeAgency'] = 'Vui lòng chọn Mã cơ quan'
        this.cAgency_exists = false
      } else {
        await this.checkCode('office_agency', this.codeAgency)
      }
      if (this.codeOffice === '') {
        this.validationErrors['codeOffice'] = 'Vui lòng nhập Mã văn phòng'
        this.cOffice_exists = false
      } else {
        await this.checkCode('office_tpl', this.codeOffice)
      }
      if (!(this.codeCourt == null || this.codeCourt=='')){
        var dateCurrent = moment().tz(this.$constants.DB_TIMEZONE).format(this.$constants.DB_FORMAT_DATE);
        var dateFrom = dateCurrent+' 00:00:00';
        var dateTo = dateCurrent+' 23:59:59';
        var whereCheckCodeExist = {
          date_receipt_court:{_gte: dateFrom,_lte: dateTo},
          code_court: {_eq: this.codeCourt.toString()},
          deleted: {_eq: false},
          status_document: {
            code: {'_eq': "WAITING"},
            deleted: {'_eq': false}
          }
        };
        var checkCodeExist = await this.$CoreService.getObjectData('document',whereCheckCodeExist);
        if (checkCodeExist){
          this.codeCourt_exists = true;
          //this.validationErrors['codeCourt'] = 'Mã VB tòa đã bị trùng.';
        }else {
          this.codeCourt_exists = false;
        }
      }else {
        this.codeCourt_exists = false;
      }
      // CHECK TẠO VĂN BẢN TRÙNG
      // if (Object.keys(this.arrDocuments).length > 0) {
      //   let keyExist = ''
      //   keyExist += this.codeArea.toString()+this.codeOffice.toString()+this.codeCourt.toString()+this.codeAgency.toString()+this.numberDecision.toString()
      //   if (keyExist in this.arrDocuments) {
      //     this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: "Trùng văn bản " + this.arrDocuments[keyExist].code_system, life: 3000 })
      //     this.cDocument_exists = true
      //   }
      // }
    },
    padLeft(nr, n, str) {
      return Array(n - String(nr).length+1).join(str || '0') + nr;
    },
    async saveData() {
      this.codeArea = '';
      this.codeOffice = '';
      this.codeAgency = '';
      if(this.codeMKV){
        if(this.codeMKV.name){
          this.codeArea = this.codeMKV.name;
        }
      }
      if(this.codeMVP){
        if(this.codeMVP.name){
          this.codeOffice = this.codeMVP.name;
        }
      }
      if(this.codeCQ){
        if(this.codeCQ.name){
          this.codeAgency = this.codeCQ.name;
        }
      }
      await this.validateData();
      if (!this.cOffice_exists && !this.cAgency_exists && !this.cDocument_exists && Object.entries(this.validationErrors).length === 0) {
        let budget = 0
        if (this.isFeeBudget !== null) {
          if (this.isFeeBudget === 'ybudget') budget = 1
          else budget = 2
        }
        // concat code system
        let cDate = moment(new Date()).format('DDMMYY');
        let cAgency = this.codeAgency.substring(0,2).toUpperCase();
        let cArea = this.codeArea.substring(0, 2).toUpperCase();
        let cOffice = this.codeOffice.substring(0, 2);
        var date1 = new Date().toISOString()
        date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        var date2 = new Date().toISOString()
        date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
        var cNumber = 0;

        await this.$apollo.query({
          query: gql(graphql.GET_SETTING_CURRENT_DOCUMENT),
          variables: {
            where: {
              created_at: {'_gte': date1, '_lte': date2}
            },
            limit: 1
          },
          fetchPolicy: "network-only"
        }).then((res) => {
          if (res.data && res.data.setting_current_document.length > 0) {
            cNumber = res.data.setting_current_document[0].current + 1
          }
        })
        let sequence =  this.padLeft(cNumber, 4);
        this.codeSystem = cDate + cAgency + cArea + cOffice + sequence;

        var objects = {
          'code_system': this.codeSystem,
          'code_court': this.codeCourt,
          'code_office': this.codeOffice,
          'code_area': this.codeArea,
          'is_urgent': this.isUrgent,
          'number_decision': this.numberDecision,
          'content_document': this.contentDocument,
          'name_litigant': this.nameLitigant,
          'address': this.address,
          'state_id': this.state && this.state.code || null,
          'district_id': this.district && this.district.code || null,
          'ward_id': this.ward && this.ward.code || null,
          'phone_litigant': this.phoneLitigant,
          'signer': this.signer,
          'code_agency': this.codeAgency,
          // 'cost_document': this.costDocument,
          'is_fee_budget': budget,
          'tdv_id': this.nameTDV && this.nameTDV.code || null,
          'phone_tdv': this.phoneTDV,
          'vplk_id': this.codeVPLK && this.codeVPLK.code || null,
          'type_document': this.type && this.type.code || 1,
          'is_import': 0,
          'status_td_id': null,
          'amount_salary': this.amount_salary,
          'type_state': this.state.type,
        }
        if(this.dateIssued !== undefined && this.dateIssued !== null){
          Object.assign(objects, {date_issued: this.dateIssued.toISOString()})
        }
        if(this.dateInvite !== undefined && this.dateInvite !== null){
          Object.assign(objects, {date_invite: this.dateInvite.toISOString()})
        }
        // check type document: viết TRIGGER trigger_check_update_type_document
        // assign TDV: admin tự assign TĐV nếu manual

        // Thêm giá của cơ quan:
        //await this.getCostDocument(this.state.code);
        await this.getCostDocument(this.state.type);
        Object.assign(objects, {cost_document: this.costDocument});
        // TẠO VĂN BẢN
        if(this.users_login !== null){
          Object.assign(objects, {created_uid: this.users_login});
        }
        await this.$apollo.mutate({
          mutation: DataServices.insertData('document'),
          variables: {
            'objects': objects
          }
        }).then(() => {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Tạo dữ liệu thành công', life: 3000 })
          this.$router.push({ path: '/admin/import-document' });
        }).catch((error) => {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Tạo dữ liệu gặp vấn đề', life: 3000 })
          console.error('ERROR: ', error)
        });
      }
    },
    async getCostDocument(type) {
      //if (stateID === 9) {
      if (type === this.$constants.TYPE_STATE.URBAN) {
        await this.$apollo.query({
          query: gql(graphql.GET_ORGAN_PRICELIST),
          variables: {
            where: {
              office_tpl_id: {'_eq': this.codeOfficeID},
              office_agency_id: {'_eq': this.codeAgencyID}
            },
            childWhere: {
              district_id: {'_eq': this.district.code}
            },
            limit: 1
          }
        }).then((res) => {
          this.costDocument = 0;
          if (res.data && res.data.organ_pricelist.length > 0) {
            let mode = res.data.organ_pricelist[0].organ_pricelist_detail[0]
            if (this.type.code === 1) this.costDocument = mode.type1
            else if (this.type.code === 2) this.costDocument = mode.type2
            else if (this.type.code === 3) this.costDocument = mode.type3
            else if (this.type.code === 4) this.costDocument = mode.type4
          }
        })
      } else {
        // Bảng giá tỉnh: lấy VB hiện tại nên ko có dữ liệu cho VB tạo mói.
        // Lúc tạo xong VB, Admin sẽ tự qua menu đó và update giá từng VB tỉnh.
      }
    },
    async getState() {
      var listState = await this.$CoreService.getListState();
      this.arrState = listState;
      if (listState.length>0){
        this.countState++;
      }
    },
    async getDictrict(stateID) {
      var model =await this.$CoreService.getDistrictByIdStateSelect(stateID);
      if(model.length>0){
        this.arrDistrict = model;
        this.countDistrict++;
      }
    },
    async getWard(districtID,state_id=null) {
      var model =await this.$CoreService.getWardByIdDistrictSelect(districtID,state_id);
      if(model.length>0){
        this.arrWard = model;
        this.countWard++;
      }
    },
    async getVPLK() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('office_vplk', {"fields" : "id name code"}),
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrVPLK = [];
        for (let i = 0; i < model.length; i++) {
          this.arrVPLK.push({'code': model[i].id, 'name': model[i].code})
        }
        this.countVPLK++;
      }
    },
    async getMKV(){
      var {data} = await this.$apollo.query({
        query: DataServices.getList('area'),
        variables : {where_key : {deleted : {'_eq' : false}}},
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrMKV= [];
        for (let i = 0; i < model.length; i++) {
          this.arrMKV.push({'code': model[i].id, 'name': model[i].code,'area_district': model[i].area_district})
        }
        this.countMKV++;
      }
    },
    async getMVP(){
      var variables = {
        where_key: {
          deleted: {_eq: false}
        },
      }
      var {data} = await this.$apollo.query({
        query: DataServices.getList('office_tpl',{"fields" : "id code office_agency_tpls {office_agency {id name code deleted}}"}),
        variables: variables,
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrMVP= [];
        for (let i = 0; i < model.length; i++) {
          this.arrMVP.push({'code': model[i].id, 'name': model[i].code, 'list': model[i].office_agency_tpls})
        }
        this.countMVP++;
      }
    },
    /*async onChangeState(e) {
      this.arrDistrict = []
      this.arrWard = []
      if (e.value !== null) {
        await this.getDictrict(e.value.code);
        // console.log(e.value.code)
      }
    },*/
    async onChangeState() {
      this.arrDistrict = []
      this.arrWard = []
      if (this.state !== null) {
        await this.getDictrict(this.state.code);
        //console.log(this.state)
        if (this.state.type == this.$constants.TYPE_STATE.OUTSIDE){
          //Nếu khác TP HCM thì load danh sách tống đạt viên theo tỉnh thành
          var listUserState =await this.$CoreService.getListUserState(this.state.code);
          this.arrTDV = listUserState;
          if (listUserState.length > 0) {
            this.countTDV++;
          }
        }
        //hiển thị vplk
        var office_id = (this.codeMVP) ? this.codeMVP.code:null;
        var state_id = (this.state) ? this.state.code:null;
        if (office_id && state_id){
          this.arrVPLK = await this.$CoreService.getListVPLKByStateVP(state_id,office_id);
        }
      }else {
        this.arrVPLK = [];
      }
    },
    async onChangeMVP(e) {
      this.codeCQ = null;
      this.arrCQ = null;
      var arr = []
      if(e.value){
        if(e.value.list !== undefined && e.value.list.length > 0){
          for (let i = 0; i < e.value.list.length; i++) {
            const ele = e.value.list[i];
            if(ele.office_agency && ele.office_agency.deleted == false){
              arr.push({"code" : ele.office_agency.id,"name" : ele.office_agency.code})
            }
          }
          this.arrCQ = arr;
        }
        //hiển thị vplk
        var office_id = (this.codeMVP) ? this.codeMVP.code:null;
        var state_id = (this.state) ? this.state.code:null;
        if (office_id && state_id){
          console.log("office_id:",office_id);
          console.log("state_id:",state_id);
          this.arrVPLK = await this.$CoreService.getListVPLKByStateVP(state_id,office_id);
        }
      }else {
        this.arrVPLK = [];
      }
    },
    async onChangeVPLK(e) {
      console.log("test==================:",e);
      this.nameTDV = null; //thay đổi VPLK thì ko có tống đạt viên
      if (e.value){
        this.amount_salary = e.value.price;
      }
    },
    async onChangeTDV(e) {
      this.phoneTDV = null;
      if(e.value !== null && e.value.phone){
        this.phoneTDV = e.value.phone;
        //Nếu thay đổi tống đạt viên thì ko chọn VPLK + set chi phí lương về 0
        this.codeVPLK = null;
        this.amount_salary = 0;
      }
    },
    async onChangeDistrict(e) {
      //console.log("onChangeDistrict:",e.value);
      console.log("onChangeDistrict:");
      this.arrWard = []
      this.ward = null;
      if (e.value !== null){
        await this.getWard(e.value.code);
      }else {
        if(this.state){
          await this.getWard(null,this.state.code);
        }
      }
    },
    /*async onChangeWard() {
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_USERS_WARD),
        variables: {
          where: {
            ward_id: {'_eq': this.ward.code},
            user: {
              users_account: {
                role: {'_eq': 'tdv'}
              }
            }
          },
          distinct_on: "user_id"
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrTDV = [];
        for (let i = 0; i < model.length; i++) {
          this.arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
        }
        this.countTDV++;
      }
    },*/
    async onChangeWard() {
      if (this.state){
        if (this.state.type == this.$constants.TYPE_STATE.URBAN){
          var listUserWard = await this.$CoreService.getListUserWard(this.ward.code);
          this.arrTDV = listUserWard;
          if (listUserWard.length > 0){
            this.countTDV++;
          }
        }
      }

    },
    async getDocument() {
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_DOCUMENT),
        variables: {
          where: {
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrDocuments = [];
        for (let i = 0; i < model.length; i++) {
          const el = model[i];
          if (el.code_area == null) el.code_area = ''
          if (el.code_office == null) el.code_office = ''
          if (el.code_court == null) el.code_court = ''
          if (el.code_agency == null) el.code_agency = ''
          if (el.number_decision == null) el.number_decision = ''
          this.arrDocuments[el.code_area+el.code_office+el.code_court+el.code_agency+el.number_decision] = el;
        }
        // console.log(this.arrDocuments)
      }
    }
  },
  async created() {
    await this.getState();
    //await this.getVPLK();
    await this.getDocument();
    await this.getMKV();
    await this.getMVP();
  },
  apollo: {
  }
}
</script>

<style lang="scss">
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
  }
}
.custom-disabled {
  background: #E5E8EB !important;
  .p-inputtext {
    background: #E5E8EB !important;
  }
  .p-dropdown-trigger {
    background: #E5E8EB !important;
  }
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>